import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
export interface FormViewRowV2Props {
  field: IFormFieldV2;
  value: any;
  valueColor?: string;
}

export const FormViewRowV2: React.FC<FormViewRowV2Props> = ({
  field,
  value,
  valueColor,
}) => {
  return (
    <Box data-testid={`form-view-${field.name}`}>
      <Text fw={500} size="sm" c="dimmed">
        {field.label}
      </Text>
      <Text size="xs" c="dimmed">
        {field.description}
      </Text>
      <Text data-testid={`form-view-${field.name}-value`} c={valueColor}>
        {value}
      </Text>
    </Box>
  );
};
